module.exports = "/_next/static/images/2287fb3c417f531d582346ec21bc07c5-blog3-lg.png";